export class RitornoPaginazione<Type> {
  total?: number;
  data?: Type;
  stampe?: any[];
  scadenze?: number;
}
